import api from "./api";

const route = "/historial";

export default {
  getHistorialProyecto: (idProyecto, params = {}) =>
    api.get(`${route}/${idProyecto}`, { params }),
};
